// The Zoo skin in the editor: one creature per sound, reacting to playback and to pad hits.
import { useEffect, useMemo } from "react";
import { LOOP_TICKS } from "@eb/shared";
import { audibleLoopTick } from "../editor/audio";
import { padListeners, padTarget } from "../editor/padInput";
import { currentView, useEditor } from "../editor/store";
import { ZooStage, zooHit, type ZooClock } from "../zoo";
import { useCalm, zooScene } from "./zooScene";

export function ZooEditor() {
  const def = useEditor((s) => s.def);
  const spec = useEditor((s) => s.spec);
  const calm = useCalm();
  useEffect(() => {
    const l = (pad: number, on: boolean, velocity: number) => {
      if (on) zooHit(padTarget(pad).slot, velocity);
    };
    padListeners.add(l);
    return () => void padListeners.delete(l);
  }, []);
  const clock: ZooClock = useMemo(
    () => ({
      position() {
        const tick = audibleLoopTick();
        return tick === null
          ? { tick: 0, lengthTicks: LOOP_TICKS, playing: false }
          : { tick, lengthTicks: LOOP_TICKS, playing: true };
      },
      events: () => currentView().events,
    }),
    [],
  );
  const scene = useMemo(() => (def && spec ? zooScene(def, spec) : null), [def, spec]);
  if (!scene) return null;
  return (
    <ZooStage
      scene={scene}
      clock={clock}
      calm={calm}
      height={220}
      className="zoo-stage"
      label="Your song's creatures, one per sound"
    />
  );
}
